export type Tomo = {
  number: number;
  title: string;
  subtitle?: string;
  description: string;
};
export type Bono = {
  number: number;
  title: string;
  description: string;
};
export type Faq = {
  question: string;
  answer: string[];
};
export type ProductFact = {
  label: string;
  value: string;
  detail: string;
};
export type AccessStep = {
  title: string;
  text: string;
};
export type ProductSpec = {
  label: string;
  value: string;
};

export const offer = {
  price: '23,99 €',
  label: 'Megapack completo · 23,99 € · Pago único',
  ctaPrimary: 'Quiero el Megapack por 23,99 €',
  ctaSecondary: 'Empieza hoy'
};

export const HEALTH_DISCLAIMER = 'Contenido educativo. No sustituye el diagnóstico, tratamiento ni asesoramiento de un profesional sanitario. Los resultados pueden variar.';

export const productFacts: ProductFact[] = [{
  label: 'Contenido',
  value: '6 tomos + 5 bonos',
  detail: 'Ruta de hábitos de 15 días, recetas y herramientas de registro.'
}, {
  label: 'Formato',
  value: 'PDF digital',
  detail: 'Para móvil, tablet u ordenador. No se envían libros físicos.'
}, {
  label: 'Acceso',
  value: 'Por email',
  detail: 'Recibes el enlace de descarga tras confirmar el pago.'
}, {
  label: 'Precio',
  value: '23,99 €',
  detail: 'Pago único, sin suscripciones.'
}];

export const painPoints: string[] = ['Desayunas «sano», pero sigues notando hinchazón abdominal.', 'Comes con normalidad y a media tarde llegan la pesadez y el cansancio.', 'Hay noches en las que no sabes si fue la comida, el estrés o el ritmo del día.', 'Pierdes horas buscando qué comer sin encontrar instrucciones claras.', 'Intentas comer bien, pero no sabes qué ajustar ni por dónde empezar.'];

export const tomos: Tomo[] = [{
  number: 1,
  title: 'El Despertar',
  description: 'Una introducción a cómo funciona la digestión y a los factores cotidianos —alimentación, descanso, estrés y rutina— que pueden influir en cómo te sientes después de comer.'
}, {
  number: 2,
  title: 'Protocolo Reset',
  subtitle: 'Fase 1 · Días 1 a 7',
  description: 'Guía para los primeros 7 días: simplificar las comidas, organizar horarios y empezar a observar cómo te sientan los alimentos.'
}, {
  number: 3,
  title: 'Protocolo Reintegro',
  subtitle: 'Fase 2 · Días 8 a 15',
  description: 'Pautas para reintroducir alimentos de forma ordenada y anotar tus sensaciones, para que puedas comentar tus observaciones con un profesional si lo necesitas.'
}, {
  number: 4,
  title: 'Botiquín Natural',
  description: 'Hábitos de apoyo para el día a día: infusiones, respiración, relajación y descanso. Incluye información general sobre suplementos, que siempre debes consultar con un profesional sanitario.'
}, {
  number: 5,
  title: 'Recetario Salud Plena',
  description: '50 recetas sencillas y prácticas con ingredientes habituales, pensadas para comer variado sin complicarte en la cocina.'
}, {
  number: 6,
  title: 'Estilo de Vida Pro-Longevidad',
  description: 'Cómo mantener los hábitos que te funcionan después de los 15 días y construir una rutina sostenible a largo plazo.'
}];

export const bonos: Bono[] = [{
  number: 1,
  title: 'Diario Anti-Hinchazón 15 Días',
  description: 'Registra comidas, sensaciones, energía y sueño para detectar patrones y tener tus observaciones ordenadas si decides consultarlas con un profesional.'
}, {
  number: 2,
  title: 'Lista Inteligente de Compras Salud Plena',
  description: 'Qué comprar y cómo organizar tu despensa y tu cocina para seguir la ruta sin dudas en el supermercado.'
}, {
  number: 3,
  title: 'Plan SOS 48 Horas',
  description: 'Una guía breve para volver a una alimentación sencilla durante 48 horas cuando notes más pesadez o hinchazón, sin abandonar tus hábitos. Si el malestar es intenso o persiste, consulta con un profesional.'
}, {
  number: 4,
  title: 'Kit para Comer Fuera de Casa',
  description: 'Ideas para elegir en restaurantes, reuniones familiares, viajes y vida social sin perder el hilo de tus hábitos.'
}, {
  number: 5,
  title: 'Ritual Digestivo Nocturno Naturia',
  description: 'Una rutina sencilla de unos 20 minutos para cerrar el día con calma y cuidar tus hábitos de cena y descanso.'
}];

export const accessSteps: AccessStep[] = [{
  title: 'Haz clic en «Quiero el Megapack por 23,99 €»',
  text: 'Irás a la página de pago segura.'
}, {
  title: 'Completa el pago',
  text: '23,99 €, pago único. Sin suscripciones ni cargos recurrentes.'
}, {
  title: 'Recibe el email de acceso',
  text: 'Con el enlace para descargar los archivos. Si no lo ves, revisa la carpeta de spam.'
}, {
  title: 'Descarga los PDF y empieza',
  text: 'Léelos en el móvil, la tablet o el ordenador, o imprímelos si lo prefieres.'
}];

export const productSpecs: ProductSpec[] = [{
  label: 'Formato',
  value: 'Archivos PDF descargables'
}, {
  label: 'Contenido',
  value: '6 tomos principales + 5 bonos'
}, {
  label: 'Envío físico',
  value: 'No. No se envían libros impresos'
}, {
  label: 'Dispositivos',
  value: 'Móvil, tablet u ordenador'
}, {
  label: 'Impresión',
  value: 'Permitida para uso personal'
}, {
  label: 'Licencia',
  value: 'Personal e intransferible'
}, {
  label: 'Precio',
  value: '23,99 € · Pago único'
}];

export const faqs: Faq[] = [{
  question: '¿Cómo recibo el Megapack después de comprar?',
  answer: ['Tras confirmar el pago, recibirás un email con el acceso para descargar los archivos. Los 6 tomos y los 5 bonos son archivos PDF.', 'Puedes leerlos en el móvil, la tablet o el ordenador, o imprimirlos. No es un producto físico: no se envían libros a domicilio.', 'Si no recibes el email, revisa la carpeta de spam o escríbenos a soporte.int@naturiasalud.com.']
}, {
  question: '¿Cuánto cuesta y cómo se paga?',
  answer: ['El Megapack completo cuesta 23,99 €, en un pago único. No hay suscripciones ni cargos recurrentes.', 'El pago se realiza en la página de pago segura a la que te lleva el botón de compra.']
}, {
  question: '¿Es para hombres y para mujeres?',
  answer: ['Sí. El contenido está pensado para cualquier persona adulta que quiera organizar mejor su alimentación y sus hábitos digestivos.']
}, {
  question: '¿Es un material médico? ¿Sustituye a un profesional?',
  answer: ['No. Es contenido educativo e informativo sobre alimentación, hábitos y bienestar digestivo. No sustituye el diagnóstico, tratamiento ni asesoramiento de un profesional sanitario.', 'No está pensado para tratar ninguna enfermedad ni para sustituir la medicación o el tratamiento que te haya indicado tu médico.']
}, {
  question: '¿Puedo usarlo si tengo un problema digestivo diagnosticado?',
  answer: ['Si tienes un diagnóstico (por ejemplo, SIBO, síndrome del intestino irritable, enfermedad de Crohn, colitis, celiaquía o alergias alimentarias), estás embarazada o en periodo de lactancia, tomas medicación o tus síntomas son intensos, nuevos o persistentes, consulta con tu profesional sanitario antes de hacer cambios en tu alimentación.', 'No interrumpas ni modifiques ningún tratamiento sin indicación médica.']
}, {
  question: '¿Qué puedo esperar de la ruta de 15 días?',
  answer: ['La ruta de 15 días es una forma de organizar tus hábitos: qué comer, cómo planificar la compra, cómo registrar tus sensaciones y cómo reintroducir alimentos con orden.', 'No promete resultados en un plazo concreto. Cada persona es diferente y los resultados pueden variar.']
}, {
  question: '¿Qué hago si como fuera de casa o viajo?',
  answer: ['El Bono 4, «Kit para Comer Fuera de Casa», reúne ideas para restaurantes, reuniones familiares, viajes y eventos sociales, para que puedas mantener tus hábitos también fuera de casa.']
}, {
  question: '¿Puedo imprimir o modificar los archivos?',
  answer: ['Puedes imprimirlos, escribir tus notas y adaptar los ejemplos a tu día a día.', 'La licencia es para uso personal: no está permitido compartir ni revender el contenido.']
}, {
  question: '¿Los 5 bonos están incluidos?',
  answer: ['Sí. Los 5 bonos forman parte del Megapack completo por 23,99 €. No existe una versión sin bonos.']
}, {
  question: '¿Y si el material no es lo que esperaba?',
  answer: ['Tienes una garantía de 7 días. Si el material no es lo que esperabas, escríbenos a soporte.int@naturiasalud.com y te devolvemos el importe.', 'Puedes consultar todos los detalles en la política de desistimiento y reembolsos, enlazada al pie de la página.']
}, {
  question: '¿Qué diferencia al Megapack de la información que encuentro en internet?',
  answer: ['El Megapack reúne en un solo lugar una ruta de hábitos de 15 días, recetas y herramientas de registro, ordenadas por etapas para que sepas por dónde empezar y cómo avanzar.']
}];
